(() => {
  if (window.__heroKpiBound) return;
  window.__heroKpiBound = true;

  function json(base, path) {
    return fetch(base + path, { credentials: "omit" }).then((res) => {
      if (!res.ok) throw new Error(String(res.status));
      return res.json();
    });
  }

  function fmtCount(n) {
    return Number(n || 0).toLocaleString();
  }

  function fmtUsd(n) {
    return "$" + Math.trunc(Number(n || 0)).toLocaleString();
  }

  function load(root) {
    if (!root || root.getAttribute("data-fetch") !== "true") return;
    const base = (root.getAttribute("data-api") || "").replace(/\/$/, "");
    if (!base) return;

    Promise.all([
      json(base, "/metadata/collection-supply").catch(() => null),
      json(base, "/opensea/collection/marketcaps").catch(() => null),
      json(base, "/coingecko/eth-price").catch(() => null),
    ]).then((results) => {
      const supply = results[0] && results[0].data;
      const caps = results[1] && results[1].data;
      const eth = results[2] && results[2].data;
      const physicalEl = root.querySelector("[data-hero-kpi-physicals]");
      const tokenEl = root.querySelector("[data-hero-kpi-tokens]");
      const capEl = root.querySelector("[data-hero-kpi-cap]");

      if (supply) {
        if (physicalEl) {
          physicalEl.textContent = fmtCount(
            (supply.unclaimedTokens || 0) + (supply.redeemableFalse || 0),
          );
        }
        if (tokenEl) {
          tokenEl.textContent = fmtCount(supply.redeemableTrue || 0);
        }
      }

      if (capEl && caps && eth && eth.ethPrice) {
        capEl.textContent =
          "Collection Cap: " +
          fmtUsd((caps.collection_market_cap_eth || 0) * eth.ethPrice);
      }
    });
  }

  document.querySelectorAll("[data-hero-kpi]").forEach(load);
})();
